import CONF from 'config/conf.singleton';
import H from 'constants/httpMethod.const';
import UMSG_TYPE from 'constants/umsg/type.const';
import { AUTH_API } from 'middleware/api';
import { fromAnyToUglyJson } from 'utils/converters/json.util';
import actionEndpointBe from 'utils/mw/actionEndpointBe.util';
import isNilValue from 'utils/predicates/any/isNilValue.util';

import {
  CREATE_DEPOSIT_BACK_END_FAILURE,
  CREATE_DEPOSIT_BACK_END_REQUEST,
  CREATE_DEPOSIT_BACK_END_SUCCESS,
} from 'cashup/actions';

export const createDepositBookingVersion = (deposit, salonId) => {
  if (!deposit.used_for_appointmentIds) deposit.used_for_appointmentIds = [];

  return {
    ATAG: createDepositBookingVersion.name,
    [AUTH_API]: {
      api_root: CONF.transactionApiRoot,
      endpoint: `deposit/${salonId}/create/`,
      authenticated: true,
      types: [CREATE_DEPOSIT_BACK_END_REQUEST, CREATE_DEPOSIT_BACK_END_SUCCESS, CREATE_DEPOSIT_BACK_END_FAILURE],
      params: { deposit, method: 'POST' },
      config: { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: fromAnyToUglyJson(deposit) },
    },
  };
};

export const createDepositCashupVersion = (deposit, salonId) => ({
  ATAG: createDepositCashupVersion.name,
  [AUTH_API]: {
    api_root: CONF.transactionApiRoot,
    endpoint: `deposit/${salonId}/create/`,
    authenticated: true,
    types: [CREATE_DEPOSIT_BACK_END_REQUEST, CREATE_DEPOSIT_BACK_END_SUCCESS, CREATE_DEPOSIT_BACK_END_FAILURE],
    params: { deposit, method: 'POST' },
    config: { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: fromAnyToUglyJson(deposit) },
  },
});

export const ibeCreateDeposit = actionEndpointBe(
  'ibeCreateDeposit',
  H.post,
  'deposit/:salonId/create/',
  (options, extra) => ({
    ...options,
    inert: true,
    isMissingParams: isNilValue(extra?.deposit),
    data: { ...(extra?.deposit ?? void 1) },
    umsg: UMSG_TYPE.global,
  }),
);
